<template>
  <div class="teacher-paper-bg">
    <exam-header>
      <div slot="extend" class="teacher-page-hd-btns">
        <router-link :to="{name:'paperCheckManage'}"
                     v-if="isAdmin"
                     class="teacher-page-hd-btn"  target="_blank">
          <i class="btn-ic ic_manger"></i>交叉批改管理
        </router-link>
        <button class="teacher-page-hd-btn" @click="showGradeExportModal=true"><i class="btn-ic ic_export"></i>一键导出成绩</button>
        <router-link
          v-if="isAdmin"
          :to="{name: 'userManageTeacher'}"
          class="teacher-page-hd-btn"
          target="_blank"
        ><i class="btn-ic ic_account"></i>用户管理</router-link>
      </div>
    </exam-header>
    <div class="teacher-paper-container">
      <div class="teacher-paper-form-warp">
        <div class="teacher-paper-title">
          <div class="teacher-paper-tab">
            <div :class="['tab-item',currTab === 0 ? 'active' : '']" @click="handleTab(0)">我的学生答卷<span/></div>
            <div :class="['tab-item',currTab === 1 ? 'active' : '']" @click="handleTab(1)">交叉批改答卷<span/></div>
          </div>
<!--          <div class="center"><span class="teacher-paper-title-icon"></span>试卷批改</div>-->
          <div class="search-btnGroup">
            <el-button type="primary" @click="handleSearch" class="search-btn btn">查询</el-button>
            <el-button @click="handleReset" class="reset-btn btn">重置</el-button>
          </div>
        </div>
        <div class="teacher-paper-search-bar">
          <!-- 查询条件区 -->
          <el-form :inline="true" class="teacher-paper-form">
            <el-form-item label="业务类型：">
              <el-select v-model="filters.level" placeholder="请选择" class="teacher-paper-select select-level" @change="handleLevelChange">
                <el-option :label="item.label" :value="item.id" v-for="(item,index) in EXAM_LEVEL_TYPE" :key="index" />
              </el-select>
            </el-form-item>

            <el-form-item label="学校信息：">
              <el-select v-model="filters.schoolId" placeholder="请选择" class="teacher-paper-select select-school" filterable>
                <el-option label="全部" value="" v-if="schoolList.length > 1" />
                <el-option :label="item.schoolName" :value="item.id" v-for="(item,index) in schoolList" :key="index" />
              </el-select>
            </el-form-item>

            <el-form-item label="考试名称：">
              <el-select
                v-model="filters.roundId"
                placeholder="请输入"
                class="teacher-paper-select select-round"
                filterable
                :loading="roundsLoading"
              >
                <!-- remote
                :remote-method="getRounds" -->
                <el-option label="全部" value="" />
                <el-option :label="item.roundName" :value="item.id" v-for="item in examRoundList" :key="item.id" />
              </el-select>
            </el-form-item>

            <el-form-item label="考生姓名：" v-if="currTab !== 1">
              <el-input v-model="filters.username" placeholder="" class="teacher-paper-input" />
            </el-form-item>

            <el-form-item label="答卷状态：">
              <el-select v-model="filters.markStatus" placeholder="请选择" class="teacher-paper-select">
                <el-option label="全部" value="" />
                <el-option label="待批改" value="0" />
                <el-option label="批改中" value="1" />
                <el-option label="成绩已核对" value="2" />
              </el-select>
            </el-form-item>

          </el-form>

        </div>
      </div>

      <div class="teacher-paper-table-warp" v-if="listLoading || (tableData && tableData.length)">
        <!-- 表格区 -->
        <el-table :data="tableData"  class="teacher-paper-table"  v-loading="listLoading">
          <el-table-column prop="roundName" label="考试名称" min-width="180" />
          <el-table-column label="考试时间" width="170" align="center">
            <template slot-scope="scope">
              {{scope.row.startTime | formatDate}}
            </template>
          </el-table-column>
          <el-table-column prop="title" label="试卷名称" min-width="120" />
          <el-table-column prop="courseExamId" label="试卷id" width="70" align="center" />
          <el-table-column prop="username" label="考生姓名" min-width="70" align="center"/>
          <el-table-column prop="school.schoolName" label="考生学校" min-width="110"  align="center">
            <template slot-scope="scope">
              <p>{{currTab === 1 && isOnlineMode ? '*' : scope.row.school?.schoolName}}</p>
            </template>
          </el-table-column>
          <el-table-column prop="markStatus" label="答卷批改状态" min-width="120" align="center">
            <template slot-scope="scope" v-if="status[scope.row.markStatus]">
              <p :class="[status[scope.row.markStatus].style,'status']"><span></span>{{status[scope.row.markStatus].label}}</p>
            </template>
          </el-table-column>
          <el-table-column prop="markMode" label="批改模式" min-width="100" align="center" >
            <template slot-scope="scope">
              <el-tag :class="[(scope.row?.markMode || 'NORMAL').toLowerCase(),'checkTag']">{{checkType[scope.row.markMode || 'NORMAL']}}</el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="level" label="业务类型" min-width="120"  align="center">
            <template slot-scope="scope">
              <el-tag class="levelTag" type="danger">{{ scope.row.level | formatLevel }}</el-tag>
            </template>
          </el-table-column>

          <el-table-column label="操作" width="100" align="center">
            <template slot-scope="scope">
              <el-button type="text"
                         :class="['teacher-paper-edit-btn']" @click="handleCheck(scope.row,'check')"
                         v-if="(currTab === 0 && (scope.row.markMode === 'NORMAL' || scope.row.canMark)) || (currTab === 1 && scope.row.markMode === 'CROSS') || !scope.row.markMode">
                <i class="el-icon-edit"></i>批改</el-button>
              <el-button type="text"
                         class="teacher-paper-edit-btn"
                         @click="handleCheck(scope.row,'preview')"
                         v-if="currTab === 0 && (scope.row.markMode === 'CROSS' && !scope.row.canMark)"> <i class="el-icon-view"></i>查看</el-button>
            </template>
          </el-table-column>
        </el-table>
        <!-- 分页 -->
        <div class="teacher-paper-pagination-bar">
          <span>共 {{ pagination.total }} 条</span>
          <el-pagination
            background
            @size-change="handleSizeChange"
            layout="prev, pager, next, jumper"
            :total="pagination.total"
            :page-size="pagination.pageSize"
            :current-page="pagination.pageNo"
            @current-change="handlePageChange"
          />
        </div>
      </div>
      <div class="teacher-paper-table-warp table-empty-warp" v-else>
        <empty-page text="未查询到相关答卷"></empty-page>
      </div>
    </div>

    <grade-export-modal
      v-if="showGradeExportModal"
      @close="showGradeExportModal=false"
    ></grade-export-modal>
  </div>
</template>
<script>
import { Form, FormItem, Select, Option, Input, Button, Table, TableColumn, Pagination,Tag } from 'element-ui';
import dayjs from 'dayjs';
import {getExamRounds, getUserExamRounds, getUserSchools} from "@/api/qzTeacher";
import {EXAM_LEVEL_TYPE, EXAM_LEVEL_TYPE_ENUM} from "@/common/constant/qz";
import ExamHeader from './components/teacherExamHeader.vue';
import gradeExportModal from './components/gradeExportModal.vue';
import EmptyPage from './components/emptyPage.vue';
import { getUser } from '@/api/user';
export default {
  name: 'TeacherPaperList',
  components: {
    "el-tag":Tag,
    "el-form":Form,
    "el-form-item":FormItem,
    "el-select":Select,
    "el-option":Option,
    "el-input":Input,
    "el-button":Button,
    "el-table":Table,
    "el-table-column":TableColumn,
    "el-pagination":Pagination,
    "exam-header":ExamHeader,
    "grade-export-modal":gradeExportModal,
    "empty-page":EmptyPage
  },
  filters: {
    formatDate(date) {
      return dayjs(date).format('YYYY-MM-DD HH:mm');
    },
    formatLevel(level) {
      return EXAM_LEVEL_TYPE_ENUM[level] || '';
    }
  },
  data() {
    return {
      EXAM_LEVEL_TYPE,
      status:{
        0:{
          label:'待批改',
          style:'un-check'
        },
        1: {
          label:'批改中',
          style:'checking'
        },
        2:{
          label:'成绩已核对',
          style:'checked'
        }
      },
      checkType:{
        CROSS: '交叉批改',
        NORMAL: '常规批改'
      },
      currTab:0,
      filters: {
        level: 'MATHS_TALENTS_1',
        markStatus: '',
        username: '',
        schoolId: '',
        roundId: ''
      },
      tableData: [],
      pagination:{
        total: 0,
        pageNo: 1,
        pageSize: 20,
      },
      showGradeExportModal: false,
      userIdentity: null,
      schoolList: [],
      examRoundList: [],
      roundsLoading: false, // 控制考试下拉框的加载状态
      listLoading: false,
      isOnlineMode: process.env.VUE_APP_MODE === 'online',
    }
  },
  computed: {
    isAdmin() {
      return (this.userIdentity?.roles || []).includes('ADMIN'); // (this.userIdentity?.roles || []).includes('ADMIN');
    },
  },
  created() {
    // 从URL中读取tab和level参数
    const query = this.$route.query;
    if (query.tab !== undefined) {
      const tab = parseInt(query.tab, 10);
      if (tab === 0 || tab === 1) {
        this.currTab = tab;
      }
    }
    if (query.level && /MATHS_TALENTS_\d/.test(query.level)) {
      this.filters.level = query.level;
    }

    this.getUserIdentity();
    this.handleReset();
    // this.getSchools(['TEACHER', 'ADMIN']).then(() => {
    //   this.getPaperList();
    // })
    this.getRounds();
  },
  methods: {
    getUserIdentity() {
      getUser().then((res) => {
        this.userIdentity = res;
      })
    },
    handleTab(tab){
      if(this.currTab === tab) return;
      this.currTab = tab;
      // 更新URL参数
      this.updateUrlParams();
      this.handleReset()
    },
    handleLevelChange() {
      this.filters.roundId = '';
      // 更新URL参数
      this.updateUrlParams();
      this.getRounds();
    },
    getPaperList(pageNo=1){
      this.listLoading = true;
      this.tableData = [];

      getUserExamRounds({
        ...this.filters,
        markMode: this.currTab === 0 ? '' : 'CROSS',
        pageSize: this.pagination.pageSize,
        pageNo: pageNo - 1 ,
      }).then(res => {
        if(res.code === 200 && res.body?.userExamRounds){
          // console.log(res.body.userExamRounds,'res.body.userExamRounds===')
          this.tableData = res.body.userExamRounds;
        }
        this.pagination = {
          ...this.pagination,
          pageNo,
          total: res.body?.totalCount,
        }
      }).catch(e => {
        this.$message.error(e?.message || '查询失败')
      }).finally(() => {
        this.listLoading = false;
      })
    },
    getSchools(roles) { //['TEACHER', 'ADMIN']
      return getUserSchools(roles).then(res => {
        if(res.code === 200 && res.body?.schools){
          this.schoolList = (res.body?.schools || []).filter(item => item.id !== 0); // 过滤掉所有学校;
          if (this.schoolList.length === 1) {
            this.filters.schoolId = this.schoolList[0].id;
          }
        }
      })
    },
    getRounds(query='') {
      // if (!query) return;
      this.roundsLoading = true;
      getExamRounds({
        roundName:query,
        level:this.filters.level
      }).then(res => {
        if(res.code === 200 && res.body?.examRounds){
          this.examRoundList = res.body?.examRounds || [];
        }
      }).finally(() => {
        this.roundsLoading = false;
      })
    },
    /**
     * 点击查询按钮
     */
    handleSearch() {
      this.getPaperList();
    },
    /**
     * 点击充值按钮
     */
    handleReset() {
      this.filters = {
        level: this.filters.level,
        markStatus: '',
        username: '',
        schoolId: this.schoolList.length === 1 && this.currTab !== 1 ? this.schoolList[0].id : '',
        roundId: '',
      }
      if(this.currTab === 0){
        this.getSchools(['TEACHER', 'ADMIN']).then(() => {
          this.getPaperList();
        })
      }else{
        this.getSchools([]).then(() => {
          this.getPaperList();
        })
      }
    },
    handleSizeChange(val) {
      this.pagination.pageSize = val;
      this.getPaperList();
    },
    handleCheck(detail,type) {
      sessionStorage.setItem('filterData',JSON.stringify({
        ...this.filters,
      }))
      const route = this.$router.resolve({
        name: 'paperDetailTeacher',
        query: {
          paperId: detail.id,
          checkType: type,
          markMode: this.currTab === 0 ? 'NORMAL' : 'CROSS'
        }
      });
      window.open(route.href, '_blank');
    },
    handlePageChange(page) {
      this.getPaperList(page);
    },
    /**
     * 更新URL参数，同步tab和level到URL
     */
    updateUrlParams() {
      const query = {
        ...this.$route.query,
        tab: this.currTab,
        level: this.filters.level
      };
      // 使用replace避免在浏览器历史中产生太多记录
      this.$router.replace({
        query
      }).catch((e) => {
        console.error('Failed to update URL params:', e);
        // 忽略导航重复的错误
      });
    }
  }
}
</script>
<style scoped lang="less">
.teacher-paper-bg {
  background: #EDE4DA;
  min-height: 100vh;
  padding-top: 72px;
  box-sizing: border-box;
}
.teacher-page-hd-btns {
  display: flex;
  gap: 10px;
}
.teacher-page-hd-btn {
  cursor: pointer;
  display: flex;
  align-items: center;
  background: #F2F3F5;
  color: #000000E5;
  font-size: 14px;
  font-weight: 500;
  height: 36px;
  padding: 0 15px;
  border-radius: 8px;
  .btn-ic {
    width: 20px;
    height: 20px;
    margin-right: 6px;
    background: center / contain no-repeat;
  }
  .ic_export {
    background-image: url('@/common/images/teacher/ic_export.png');
  }
  .ic_manger{
    background-image: url('@/pages/teacher/images/check.png');
  }
  .ic_account {
    background-image: url('@/common/images/teacher/ic_account.png');
  }
}
.teacher-paper-container {
  max-width: 1400px;
  margin: 24px auto;
  padding: 0 24px 40px;
}
.teacher-paper-form-warp{
  background: #fff;
  padding: 40px;
  border-radius: 12px 12px 0 0;
}
.teacher-paper-title {
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 24px;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  .center {
    display: flex;
    align-items: center;
    font-size: 24px;
    color: #243342;
  }
  .teacher-paper-tab{
    display: flex;
    align-items: flex-start;
    gap: 40px;
    font-weight: 500;
    .tab-item {
      display: flex;
      font-size: 20px;
      flex-direction: column;
      color: #86909C;
      align-items: center;
      cursor: default;
      &.active {
        color: #1D2129;
        span{
          background: #E60012;
          border-radius: 90px;
          height: 5px;
          width: 60px;
          margin-top: 6px;
        }
      }
    }
  }
}
.teacher-paper-title-icon {
  width: 30px;
  height: 30px;
  background: url("@/common/images/teacher/ic_paper.png") center / contain no-repeat;
  margin-right: 3px;
}
.teacher-paper-search-bar{
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.search-btnGroup{
  display: flex;
  align-items: center;
  .btn{
    width: 92px;
    height: 36px;
    border-radius: 90px;
    font-size: 14px;
    border: none;
  }
  .search-btn {
    color: #FFFFFF;
    background: #E60012;
    margin-right: 16px;
  }
  .reset-btn{
    color: #000000;
    background: #F2F3F5;
  }
}
.teacher-paper-form {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-wrap: wrap;
  gap: 16px;
  /deep/ .el-form-item__label{
    font-size: 16px;
    font-weight: bold;
    padding: 0 4px 0 0;
    color: #1D2129;
  }
  /deep/ .el-form-item{
    margin-bottom: 0;
    margin-right: 0;
  }
}
.teacher-paper-select {
  width: 130px;
  &.select-level {
    width: 160px;
  }
  &.select-school {
    width: 180px;
  }
  &.select-round {
    width: 230px;
  }
}
.teacher-paper-input {
  width: 120px;
}
.teacher-paper-table-warp{
  padding: 24px 40px 40px;
  background: #F7F6F5;
  border-radius:0 0 12px 12px;
}
.teacher-paper-table {
  width: 100%;
  margin-bottom: 48px;
  border-radius: 12px;
  .status{
    display: flex;
    align-items: center;
    justify-content: center;
    span{
      width: 6px;
      height: 6px;
      border-radius: 50%;
      margin-right: 4px;
    }
    &.un-check{
      span{
        background: #D9D9D9;
      }
    }
    &.checking{
      span{
        background: #19B21E;
      }
    }
    &.checked{
      span{
        background: #BD9F68;
      }
    }
  }
    /deep/ td.el-table__cell {
    border: none;
    .checkTag{
      width: 68px;
      height: 24px;
      line-height: 24px;
      font-size: 12px;
      font-weight: 400;
      border: none;
    }
    .cross{
      background: #FAEDD6;
      color: #86909C;
    }
    .normal{
      background: #F2F3F5;
      color: #86909C;
    }
    .levelTag{
      font-weight: 500;
      background: linear-gradient(270deg, rgba(255, 233, 233, 0.6) 0%, rgba(255, 240, 230, 0.6) 100%);
      border-radius: 4px;
      height: 24px;
      line-height: 24px;
      color: #D03C48;
      border: none;
    }
  }
  /deep/ th.el-table__cell {
    border: none;
  }
  /deep/ .el-table__body{
    tr{

    }
    .el-table__cell{
      padding: 10px 0;
      &:first-child {
        padding-left: 30px;
      }
    }
  }
  /deep/ .el-table__header{
    thead{
      color: #000000;
      tr{
        background: #F7F1E6;
        th{
          font-weight: 500;
          background: #F7F1E6;
          &:first-child {
            padding-left: 30px;
          }
        }
      }
    }
    height: 60px;
  }
}
.teacher-paper-edit-btn {
  color: #c9a96a;
  i{
    margin-right: 2px;
  }
  &.disable{
    color: #C9CDD4;
    cursor: not-allowed;
    //pointer-events: none;
  }
}
.teacher-paper-pagination-bar {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  /deep/ .el-pager li.active{
    color: #E60012 !important;
    background-color: transparent !important;
  }
}
</style>
<style>
.el-table--enable-row-hover .el-table__body tr:hover>td.el-table__cell{
  background-color: #FAFAFA !important;
}
</style>